import { recordElementClicked } from '@streem/analytics';
export function recordCallTransferButtonClicked() {
    recordElementClicked('call-transfer-button-clicked');
}
export function recordTradeClicked(trade) {
    recordElementClicked(`trade-${trade}-hovered`);
}
export function recordRequeueClicked(trade) {
    recordElementClicked(`requeue-button-for-${trade}-clicked`);
}
export function recordRequeueConfirmationCanceledClicked() {
    recordElementClicked('requeue-confirmation-cancel-clicked');
}
export function recordRequeueConfirmationConfirmedClicked() {
    recordElementClicked('requeue-confirmation-confirm-clicked');
}
//# sourceMappingURL=analytics-utils.js.map